import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import ValidationError from "~/Components/Forms/ValidationError";
import Translated from "~/Admin/AdminMultilang/Translated";

const AdminEventSubmittedRegistrationMessage = ({match, event, onChange, ...props}) => {

    const [form, setForm] = useState({
        allMessages: event?.submitted_message_groups,
        message: event.submitted_message?.message,
        guest_group: event.submitted_message?.guest_group,
    });
    const [currentSelected, setCurrentSelected] = useState('local');

    const locales = {
        local: "Local",
        international: "International",
    }

    const [error, setError] = useState(null);
    const [actionMessage, setActionMessage] = useState('');

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setForm({...form, [name]: value});
    };

    const handleSubmit = () => {
        adminHttp
            .put(`/events/${event.id}/registration-submitted-messages`, form)
            .then(res => {
                setError(null);
                setActionMessage('Saved successfully!');

                if (onChange) {
                    onChange();
                }

            }).catch((error) => {
            setActionMessage(null);
            setError(error.response?.data);
        });
    };

    const handleLocaleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setCurrentSelected(value);
        setForm({...form, [name]: value, message: form.allMessages[value]});
    }

    useEffect(() => {
        setForm({
            allMessages: event?.submitted_message_groups || {},
            message: event?.submitted_message_groups[currentSelected],
            guest_group: currentSelected,
        })
    }, [event])

    return (
        <div>
            <div>
                <select
                    name="guest_group"
                    className="form-control mb-2"
                    defaultValue={currentSelected}
                    onChange={handleLocaleChange}
                >
                    {Object.keys(locales).map((locale, idx) =>
                        <option key={`gdpr_locale${idx}`} value={locale}>{locales[locale]}</option>
                    )}
                </select>
            </div>

            <div className="card shadow-sm bg-white">
                <div className="card-body">

                    {actionMessage && (
                        <div className="alert alert-success" role="alert">
                            {actionMessage}
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving event!"}
                        </div>
                    )}

                    <div className="form-group required">
                        <label>Submitted Registration Message</label>

                        {/* <Translated translations={form.translations}
                                    onChanged={(values) => setForm({...form, translations: values})}> */}
                            <textarea
                                onChange={handleChange}
                                value={form?.message|| ''}
                                name="message"
                                className="form-control"/>
                        {/* </Translated> */}

                        <ValidationError errors={error?.errors} name="message"/>
                    </div>
                </div>
            </div>
            <button
                onClick={handleSubmit}
                className="btn btn-primary text-cta float-right mt-3">
                Save
            </button>
        </div>

    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventSubmittedRegistrationMessage);
